module.exports = __webpack_public_path__ + "assets/montserrat-medium.54186c0572e2e0b499adb01eda48e2ff2aec07c92c756a60f3729391fe6ccc0c.woff2";